import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import {
  getRequiredFields,
  removeEmptyFields,
  setEmptyFieldsToNull,
} from "@/lib/utils";
import {
  CREATED_BY,
  DATE_RANGE,
  END_DATE,
  INVOICE_STATUS,
  PAYMENT_STATUS,
  START_DATE,
  VENDOR_ID,
} from "../consts";
import { useIsMobile } from "@/hooks/use-mobile";
import { formValues, schema } from "./validations";
import { useEffect } from "react";
import { useGetVendorListByCommunityId } from "@/services";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

const useFilter = ({
  filterData,
  setFilterData,
  onCancel,
}: {
  filterData: any;
  setFilterData: React.Dispatch<React.SetStateAction<any>>;
  onCancel: () => void;
}) => {
  const isMobile = useIsMobile();

  const form = useForm<formValues>({
    resolver: zodResolver(schema),
    defaultValues: {
      [DATE_RANGE]: "",
      [VENDOR_ID]: "",
      [INVOICE_STATUS]: "",
      [CREATED_BY]: "",
      [PAYMENT_STATUS]: "",
    },
  });

  const communityDetail = useSelector(
    (state: RootState) => state.currentData.communityData
  );

  useEffect(() => {
    if (filterData) {
      form.reset({
        [DATE_RANGE]: filterData?.[DATE_RANGE] || "",
        [VENDOR_ID]: filterData?.[VENDOR_ID] || "",
        [INVOICE_STATUS]: filterData?.[INVOICE_STATUS] || "",
        [CREATED_BY]: filterData?.[CREATED_BY] || "",
        [PAYMENT_STATUS]: filterData?.[PAYMENT_STATUS] || "",
      });
    }
  }, [filterData]);

  const requiredFields = getRequiredFields(schema);

  const onSubmit = (data: formValues) => {
    let _data = removeEmptyFields(data);
    _data = setEmptyFieldsToNull(data);
    setFilterData({
      ..._data,
      [START_DATE]: (_data[DATE_RANGE] as any)?.startDate,
      [END_DATE]: (_data[DATE_RANGE] as any)?.endDate,
    });
    onCancel();
  };

  const onClear = () => {
    setFilterData(null);
    onCancel();
  };

  const { data: vendorList, isLoading: isVendorLoading } =
    useGetVendorListByCommunityId({
      communityId: communityDetail?.communityId,
      queryParams: {
        enabled: !!communityDetail?.communityId,
      },
    });

  return {
    form,
    onSubmit,
    requiredFields,
    isMobile,
    onClear,
    isVendorLoading,
    vendorList,
  };
};

export default useFilter;
